// @ts-check
import moment from 'moment';
import { DATE_FORMAT } from 'common/constants/constants';
import useStatus from './useStatus';

const LastUpdatedAt = () => {
  const status = useStatus();

  if (!status?.last_updated_at) return null;

  const lastUpdatedAt = moment(status?.last_updated_at).format(DATE_FORMAT);

  return (
    <div className='text-xs flex flex-col mx-2'>
      <span className='whitespace-nowrap'> Data updated: </span>
      <span>{lastUpdatedAt}</span>
    </div>
  );
};

export default LastUpdatedAt;
